import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import VuetifyNotify from "@tt/vuetify-notify-plugin";
Vue.use(VuetifyNotify, { vuetify });
Vue.use(VuetifyNotify, { vuetify: vuetify, target: ".v-main__wrap"}, );
